<div class="table mt-4">
  <div class="table-wrapper">
    <table class="table">
      <thead *ngIf="showTableHeader">
        <tr>
          <th scope="col" *ngIf="showCheckBoxes">
            <input
              type="checkbox"
              [checked]="isAllSelected()"
              (change)="toggleAllRows($event)"
            />
          </th>
          <th
            scope="col"
            class="id"
            *ngFor="let item of columns; let i = index"
          >
            <div class="sortable-row" (click)="sort(sortKey[item.key])">
              <span
                [translatable]="{
                  transKey: item.columnLabel,
                  modEnum: translationModulesEnum[modEnum]
                }"
              >
                {{ item.columnLabel | translate }}
              </span>
              <div
                class="sort-icon"
                *ngIf="isTableSortable"
                [ngClass]="{
                  'sort-up':
                    sortedCol && sortedCol == sortKey[item.key] && ascMode,
                  'sort-down':
                    sortedCol && sortedCol == sortKey[item.key] && descMode
                }"
              >
                <i class="bx bxs-up-arrow"></i>
                <i class="bx bxs-down-arrow"></i>
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="
            let item of list
              | paginate
                : {
                    itemsPerPage: paginationModel?.pageSize,
                    currentPage: paginationModel?.pageIndex,
                    totalItems
                  };
            let i = index
          "
        >
          <td *ngIf="showCheckBoxes">
            <!-- Row Checkbox -->
            <input
              type="checkbox"
              [(ngModel)]="item.selected"
              (change)="onRowSelect(item)"
            />
          </td>
          <ng-container *ngFor="let column of columns; let j = index">
            <td *ngIf="column.type === 'link'">
              <a
                *ngIf="isLink; else plainLinkText"
                class="hoverableLink"
                [routerLink]="link + item?.id"
              >
                {{ item?.[column.key] | availability }}
              </a>
              <ng-template #plainLinkText>
                <span>
                  {{ item?.[column.key] | availability }}
                </span>
              </ng-template>
            </td>
            <td *ngIf="column.type === 'photo'">
              <!-- <span *ngIf="item?.title || item?.name">

              </span>
              <span>
                {{ item?.[column.key] }}
              </span> -->
              <a
                class="hoverableLink"
                [routerLink]="link + item?.id"
                *ngIf="isLink && item?.[column.isLink]"
              >
                <img
                  [src]="item?.[column.key]"
                  [style.width.px]="column?.width ? column.width : 50"
                  [style.height.px]="column?.height ? column.height : 50"
                  [style]="
                    'width: ' +
                    (column?.width ?? 50) +
                    'px; height: ' +
                    (column?.height ?? 50) +
                    'px;'
                  "
                alt="photo"
                class="table-photo"
              />
              </a>
              <img
                [src]="item?.[column.key]"
                [style.width.px]="column?.width ? column.width : 50"
                [style.height.px]="column?.height ? column.height : 50"
                [style]="
                  'width: ' +
                  (column?.width ?? 50) +
                  'px; height: ' +
                  (column?.height ?? 50) +
                  'px;'
                "
                alt="photo"
                class="table-photo"
                *ngIf="!isLink || !item?.[column.isLink]"
              />
            </td>
            <td *ngIf="column.type === 'text'">
              <span *ngIf="item?.title || item?.name">
                <!-- <span *ngIf="item?.title">
                {{ item?.[column.key] }}
              </span> -->
              </span>
              <span>
                {{ item?.[column.key] | availability }}
              </span>
              <span>
                {{ column.hasCurrency ? item.currency : "" }}
              </span>
            </td>
            <td *ngIf="column.type === 'description'">
              <span>
                <div
                  class="info__text"
                  [innerHTML]="item?.[column.key] | truncate : 50 | availability "
                ></div>
              </span>
            </td>
            <td *ngIf="column.type === 'innerHTMLText'">
              <span *ngIf="item?.title || item?.name">
                <!-- <span *ngIf="item?.title">
                {{ item?.[column.key] }}
              </span> -->
              </span>
              <span [innerHTML]="item?.[column.key] | availability"></span>
            </td>
            <td *ngIf="column.type === 'date'">
              <span class="opacity-50">
                {{
                   (item?.[column.key]  | uTCToLocalDate | localizedDate : "d MMM y")

                }}
              </span>
            </td>
            <td *ngIf="column.type === 'dateTime'">
              <span class="opacity-50">
                {{
                  (item?.[column.key] | uTCToLocalDate | localizedDate : "d MMM y - h:mm a")
                }}
              </span>
            </td>
            <td *ngIf="column.type === 'time'">
              <span class="opacity-50">
                {{
                   (item?.[column.key]  | uTCToLocalDate | localizedDate : "h:mm a")
                }}
              </span>
            </td>
            <td *ngIf="column.type === 'status'">
              <ng-container
                *ngIf="
                  column.parentComponent &&
                    column.parentComponent == 'paymentInformation';
                  else object_status
                "
              >
                <span *ngIf="item?.status">
                  <app-badge
                    [className]="item?.status?.toLowerCase()"
                    [label]="item?.[column.key]"
                  ></app-badge>
                </span>
              </ng-container>
              <ng-template #object_status>
                <span
                  *ngIf="
                    item?.status ||
                    item?.criteriaStatus ||
                    item?.deliveryMethod ||
                    item?.transactionStatus ||
                    item?.paymentStatus
                  "
                >
                  <ng-container *ngIf="column.enum; else normalBadge">
                    <app-status-flag
                      [statusName]="item?.[column.key]?.name?.toLowerCase() || item?.criteriaStatus?.name?.toLowerCase() || item?.status?.toLowerCase()"
                      [statusCode]="item?.[column.key]?.id || item?.criteriaStatus?.id || item?.statusCode"
                      [statusMap]="column.enum"
                    ></app-status-flag>
                  </ng-container>
                  <ng-template #normalBadge>
                    <app-badge
                      [className]="
                        item?.status?.name?.toLowerCase() == 'in active' ||
                        item?.criteriaStatus?.name?.toLowerCase() ==
                          'in active' ||
                        item?.criteriaStatus?.name?.toLowerCase() ==
                          'in progress'
                          ? 'offTrack'
                          : item?.status?.name?.toLowerCase() ||
                            item?.criteriaStatus?.name?.toLowerCase() ||
                            item?.deliveryMethod?.name?.toLowerCase() ||
                            item?.transactionStatus?.name?.toLowerCase()
                      "
                      [label]="item?.[column.key].name"
                    ></app-badge>
                  </ng-template>
                </span>
              </ng-template>
            </td>
            <td *ngIf="column.type === 'actions' && column.buttons">
              <div
                class="d-flex justify-content-start align-items-center gap-2"
              >
                <ng-container *ngFor="let button of column.buttons">
                  <div
                    *ngIf="shouldShowButton(button, item)"
                    [translatable]="{
                      transKey: button.label,
                      modEnum: button.modEnum
                    }"
                  >
                    <button
                      [ngClass]="button.className"
                      (click)="handleAction(button.actionType, item)"
                    >
                      <span [innerHTML]="button.icon"></span>
                      {{ button.label | translate }}
                    </button>
                  </div>
                </ng-container>
              </div>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- numeric pagination controls -->
<ng-container *ngIf="hasPagination">
  <div class="row justify-content-between">

   <div class="col-auto align-self-center" *ngIf="(totalItems > paginationModel?.pageSize) || (totalItems < paginationModel?.pageSize && paginationModel?.pageSize !== 10)">
      <select class="form-select" [ngModel]="itemsPerPage" (ngModelChange)="onItemsPerPageChanged($event)">
          <option *ngFor="let item of itemsPerPageList" [selected]="item?.value == selectedItemsPerPage" [value]="item?.value">{{item?.value}}</option>
      </select>
  </div>
  <pagination-controls
    *ngIf="autoHidePagination || totalItems > paginationModel?.pageSize"
    (pageChange)="onPaginate($event)"
    class="my-pagination col-auto"
    maxSize="5"
    responsive="true"
    [previousLabel]="translate.instant('shared.prev')"
    [nextLabel]="translate.instant('shared.next')"
  ></pagination-controls>
  <div class="d-flex justify-content-end gap-5">
    <span
      class="mx-5"
      [translatable]="{
        transKey: 'shared.prev',
        modEnum: translationModulesEnum[modEnum]
      }"
    ></span>
    <span
      class="mx-5"
      [translatable]="{
        transKey: 'shared.next',
        modEnum: translationModulesEnum[modEnum]
      }"
    ></span>
  </div>
  </div>
 
</ng-container>
